import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const refundRoutes: RouteRecordRaw[] = [
  {
    path: '/refunds',
    name: ROUTES.REFUNDS,
    component: () => import('@/modules/refunds/views/RefundsIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.REFUNDS_VIEW }
  }
]
